import { getRecaptchaTokenSync } from './recaptchaToken';

let session: { id: string };
let initialized = false;

export const initSession = async (): Promise<string> => {
  if (initialized && session) return session.id;
  const { VITE_BASE_API_URL } = import.meta.env;

  const recaptchaToken = await getRecaptchaTokenSync();

  const res: Response = await fetch(`${VITE_BASE_API_URL}/session`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      traceparent: '', //Replace with OTEL trace id if available
      'x-date-override': new Date().toISOString(),
      'x-interaction-id': crypto.randomUUID(),
      'x-recaptcha-token': recaptchaToken ?? '',
    },
  });

  session = await res.json();
  initialized = true;
  return session.id;
};

export const getSessionSync = (): { id: string } | null => session ?? null;

export const setSession = (id: { id: string }) => {
  session = id;
  initialized = true;
};
